//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * 共享业务员-个人form
 * @author Spark
 */
import FormMixins from '~/mixins/form-mixins';
import SubFormMixins from "./form-mixins";
import CommonUtils from 'utils/CommonUtils';
export default {
  name: 'module-gongxiang-geren',
  mixins: [FormMixins, SubFormMixins],
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      model: {
        // 本人姓名
        name: null,
        // 性别 0 男性 1女性
        sex: null,
        // 出生日期
        birthday: null,
        // 民族
        nation: null,
        // 籍贯
        nativePlace: null,
        // 微信号
        wxNum: null,
        // 介绍人
        introducer: null,
        // 常住地址
        commonAddress: null,
        // 紧急联络人
        emergencyContactName: null,
        // 与本人关系
        emergencyContactRelatives: null,
        // 联系方式
        emergencyContactPhone: null,
        // 最擅长的经营范围
        areasOfExpertise: null,
        // 工作经历
        workExperience: null,
        // 目前就职企业
        currentIncumbentEnterprises: null,
        // 身份证正面
        idCardAddressPositiveImg: null,
        // 身份证背面
        idCardAddressBackImg: null
      },
      sexColumns: ['男性', '女性'],
      showSexPicker: false,
      showBirthdayPicker: false,
      birthdayDate: null
    };
  },
  methods: {
    formatDate: CommonUtils.format,
    handleUploadIdCardImgPositive: function handleUploadIdCardImgPositive(img) {
      this.model.idCardAddressPositiveImg = img;
    },
    handleUploadIdCardImgBack: function handleUploadIdCardImgBack(img) {
      this.model.idCardAddressBackImg = img;
    },

    /**
     * 选择性别
     * @param value
     * @param index
     */
    onSexConfirm: function onSexConfirm(value, index) {
      this.model.sex = index;
      this.showSexPicker = false;
    },
    // 选择生日
    onBirthdayConfirm: function onBirthdayConfirm(value) {
      this.birthdayDate = value;
      this.model.birthday = this.formatDate(value, 'yyyy-MM-dd');
      this.showBirthdayPicker = false;
    }
  }
};